export default {
    data() {
        return {
            uid: 'input-' + this._uid,
        }
    },
}
